import routes from './routes'

export { routes }



// WEBPACK FOOTER //
// ./src/containers/FlagInappropriate/index.js